import { E2EInterceptor, AuthenticationInterceptor } from './interceptors';
import { HttpClientModule,
         HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: E2EInterceptor,
      multi: true
    }
  ],
  imports: [
    HttpClientModule
  ]
})
export class CommonwealthHttpModule { }